import {makeStyles} from "@material-ui/core/styles";

const StyleHeader = makeStyles(theme => ({
    root: {
        backgroundColor: theme.palette.primary + '!important',
        marginBottom: theme.spacing(0.25),
        flexGrow: 1
    },
    appTitleHeading: {
        width: '100%',
        marginLeft: 10
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0.5, 0),
    },
    drawerList: {
        display: 'flex',
        flexDirection: 'column',
        width: 250,
        paddingTop: 0,
    },
    resetData: {
        color: theme.palette.error.main,
    },
    deleteData: {
        color: theme.palette.error.main,
    },
    resultTest: {
        width: '100%',
        textAlign: 'right',
        marginRight: 10
    },
    iconColor: {
        color: '#ED3237',
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

export default StyleHeader;